export default __webpack_public_path__ + "static/media/avatar9.35ecff63.svg";